// NOTE: 'store' としてしまうと課金プラグインと競合する
import vueStore from '@/store'
import * as _ from 'lodash'
import { hasCordova, platformIsIOS } from '@/cordova'

const vuex = JSON.parse(localStorage.getItem('vuex'))

/**
 * store か locationStorage['vuex'] から store state を取得
 */
const getStoreState = (storeName: string, stateName: string): any => {
  if (vueStore) {
    return vueStore.getters[`${storeName}/${stateName}`]
  } else if (vuex) {
    return _.get(vuex, `${storeName}.${stateName}`)
  } else {
    return null
  }
}

const tagsContext = {}
const userContext = {
  token: getStoreState('Auth', 'token')
}
if (hasCordova) {
  tagsContext['appVersion'] = getStoreState('AppInfo', 'appVersion')
  userContext['device_token'] = getStoreState('MyData', 'deviceToken')
  if (platformIsIOS) {
    userContext['voip_device_token'] = getStoreState('MyData', 'voipDeviceToken')
  }
} else {
  tagsContext['webVersion'] = getStoreState('AppInfo', 'webVersion')
}

export default {
  tagsContext: tagsContext,
  userContext: userContext
}
